export default "__VITE_ASSET__D$Jnx_j9__"